import { createStore } from 'vuex';
import state from './state';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';
import globalDialog from './modules/globalDialog';
import globalGuideDialog from './modules/globalGuideDialog';
import globalFeedbackDrawer from './modules/globalFeedbackDrawer';
import jm from './modules/jm';
import watchList from './modules/watchList';
import openClaw from './modules/openClaw';
import stockRealtime from './modules/stockRealtime';
import stock from './modules/stock';
import globalAudioPlayback from './modules/globalAudioPlayback';

const store = createStore({
  state() {
    return {
      ...state
    };
  },
  getters: {
    ...getters
  },
  mutations: {
    ...mutations
  },
  actions: {
    ...actions
  },
  modules: {
    globalDialog,
    globalGuideDialog,
    globalFeedbackDrawer,

    // 进门登录后 单独管理其状态
    jm,
    // 自选股
    watchList,
    // OpenClaw 对话状态（按 sessionId 持久化，路由切换可恢复）
    openClaw,
    // 股票实时行情（订阅 + 轮询）
    stockRealtime,
    // 个股实时信息
    stock,
    // 全局音频播放条（根组件挂载，跨路由保留实例）
    globalAudioPlayback
  }
});

// 个股 WS channel 管理器在 stock 模块首次 subscribeCodes 时按需懒装，
// 避免页面进入即注册下行订阅与定时器；安装入口见 src/store/modules/stock/index.js -> ensureChannelManager

export default store;

let _comeinAiChatPromise = null;
export function registerComeinAiChatModule() {
  if (store.hasModule('comeinAiChat')) return Promise.resolve();
  if (_comeinAiChatPromise) return _comeinAiChatPromise;
  _comeinAiChatPromise = import('./modules/comeinAiChat').then(({ default: module }) => {
    if (!store.hasModule('comeinAiChat')) {
      store.registerModule('comeinAiChat', module);
    }
    _comeinAiChatPromise = null;
  });
  return _comeinAiChatPromise;
}
